

export const getProvinceByIds = async (lang: string, ids: number[]) => {
    try {
        // const ids = [1, 4, 2, 3, 58, 11, 12, 38, 66, 19];
        const url = `${process.env.BACK_END_URL 
            || process.env.NEXT_PUBLIC_BACK_END_URL}/province?ids=[${ids.join(',')}]`;

        const res = await fetch(encodeURI(url),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Accept-Language': `${lang.toUpperCase()}`
                }
            }
        )
        const data = await res.json()

        if (!data) {
            return {
                notFound: true,
            }
        }
        return data;
    } catch (e) {
        console.log('search error: ', e)
        return [];
    } 
}